import script from "./TriageSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./TriageSelect.vue?vue&type=script&setup=true&lang=ts"

import "./TriageSelect.vue?vue&type=style&index=0&id=734f640c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/uup/uup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-734f640c"]])

export default __exports__